module.exports = __webpack_public_path__ + "bdd2b88b5f2b88fe7fa3faf89861b2a8.svg";